import { TranslateService } from '@project/translate';

export enum EProfileTagsDTO {
  None = 0,
  Health = 1,
  School = 2,
  Prision = 3,
  Admin = 4,
  Municipality = 5,
  Private = 6,
}

export enum EProfileTagsStringDTO {
  None = 'Undefined',
  Health = 'Health',
  School = 'School',
  Prision = 'Prision',
  Admin = 'Admin',
  Municipality = 'Municipality',
  Private = 'Private',
}

export function getProfileTagsTranslations(profileTags: EProfileTagsStringDTO): string | undefined {
  const map: Record<EProfileTagsStringDTO, () => string> = {
    [EProfileTagsStringDTO.None]: () => TranslateService.localize('profile-tags.undefined'),
    [EProfileTagsStringDTO.Health]: () => TranslateService.localize('profile-tags.health'),
    [EProfileTagsStringDTO.School]: () => TranslateService.localize('profile-tags.school'),
    [EProfileTagsStringDTO.Prision]: () => TranslateService.localize('profile-tags.prision'),
    [EProfileTagsStringDTO.Admin]: () => TranslateService.localize('profile-tags.admin'),
    [EProfileTagsStringDTO.Municipality]: () => TranslateService.localize('profile-tags.municipality'),
    [EProfileTagsStringDTO.Private]: () => TranslateService.localize('profile-tags.private'),
  };
  return map[profileTags]?.();
}
